import { Component, inject, OnInit, AfterViewInit, signal } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule, Validators, FormArray } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule, formatDate } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { PdfService } from '../../../core/services/pdf-service/pdf-service';
import { RepAssessmentForm } from '../../../core/interfaces/repassessmentform.interface';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { AgentOnboardingService } from '../agent-onboarding/agent-onboarding-service/agent-onboarding.service';
import { ConfirmPopupComponent } from '../new-rep-application/confirm-popup/confirm-popup.component';
import { HttpStatusCode } from 'axios';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { viewIntroducerRepAssessment } from './introducer-rep-assessment-interface/introducer-rep-assessment.interface';
import { IntroducerRepAssessmentService } from './introducer-rep-assessment-service/introducer-rep-assessment.service';
import { NewIntroducerChecklistService } from '../new-introducer-checklist/new-introducer-checklist-services/new-introducer-checklist.service';
import { getChecklistItems } from '../new-rep-checklist/new-rep-checklist-interfaces/save-new-rep-checklist.interface';
import { IntroducerRepAssessment } from './introducer-rep-assessment-models/introducer-rep-assessment.models';
import { SelectOptions } from '../../../core/interfaces/select-options.interface';
import { OnboardingAssesment } from '../onboarding-assessment/onboarding-assesment-interface/onboarding-assesment.interface';
import { OnboardingAssessmentService } from '../onboarding-assessment/onboarding-assessment-services/onboarding-assessment.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OnboardingAssesmentModel } from '../onboarding-assessment/onboarding-assesment-models/onboarding-assesment-model.model';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentPreviewOverlayDirective } from '../../../shared/directives/document-preview-overlay/document-preview-overlay.directive';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-introducer-rep-assessment',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIcon,
    MatButtonModule,
    MatCheckboxModule,
    CommonModule,
    MatDatepickerModule,
    MatSelectModule,
    MatTooltipModule,
    DocumentPreviewOverlayDirective
  ],
  templateUrl: './introducer-rep-assessment.component.html',
  styleUrl: './introducer-rep-assessment.component.scss'
})
export class IntroducerRepAssessmentComponent implements OnInit {

  readonly message = 'This field is required.';
  private fb = inject(FormBuilder);
  private pdfService = inject(PdfService);
  private matDialog = inject(MatDialog);
  private sanitizer = inject(DomSanitizer);
  private sessionStorageService = inject(SessionStorageService);
  private returnbyroleService = inject(AgentOnboardingService);
  private introducerRepAssessmentService = inject(IntroducerRepAssessmentService);
  private newIntroducerChecklistService = inject(NewIntroducerChecklistService);
  private documentUploadService = inject(OnboardingAssessmentService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  public repassessment: FormGroup = this.fb.group({
    repName: [''],
    interviewDate: ['', [Validators.required]],
    date: [''],
    basicRecommendations: [''],
    repCode: [''],
    branch: [''],
    representative: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
    introducer: ['', [Validators.required, , Validators.min(0), Validators.max(100)]],
    declarationaccepted: ['', [Validators.required]],
    decleredrepName: [''],
    rectificationAttachemnts: this.fb.array([]),
    rectificationRecommendations: [''],

  },
    { validators: this.splitPercentageValidator });
  setSprinner = signal(false);
  data = history.state;
  viewId!: number;
  viewintroducerRmassessment!: viewIntroducerRepAssessment;
  isReadOnly = signal(false);
  protected currentUserRole: string = "";
  protected status: string = "";
  submitted = signal(false);
  errormessage!: string;
  role!: string;
  designation!: string;

  protected getchecklistItems: getChecklistItems[] = [];
  checklistinvalidflag = signal(false);
  protected documentCategorynames!: SelectOptions[];
  getRectificationdocuments!: OnboardingAssesment[];

  /** Prefix used for the dynamically added "Other Attachments" controls. */
  readonly otherAttachmentPrefix = 'otherAttachment';
  /** Document type sent for every "Other Attachments" upload - the row index goes in responseValue. */
  readonly otherAttachmentDescription = 'OtherAttachments';
  /** Control keys of the rendered "Other Attachments" rows, e.g. ['otherAttachment1', 'otherAttachment2']. */
  otherAttachmentKeys: string[] = [];
  private otherAttachmentSeq = 0;
  /**
   * The "Other Attachments" rows of the documents list, kept apart from
   * getRectificationdocuments so the rectification FormArray's existing
   * positional lookups (removeRow / removeFile / loadFile) stay aligned.
   */
  private otherAttachmentDocuments: OnboardingAssesment[] = [];

  selectedDocument!: SafeResourceUrl;
  isPdf = false;
  selectedItemFile!: string;
  currentFileName!: string;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;

  ngOnInit(): void {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.designation = this.data.designation;
    this.viewId = this.data.id;
    this.isReadOnly.set(this.data.isReadOnly);
    if (this.designation == 'Introducer - Individual') {
      this.role = 'INDIVIDUAL';
    } else {
      this.role = 'CORPORATE';
    }
    this.viewIntroducerRepAssessment();
    this.getChecklistItems();
    if (this.isReadOnly() == true) {
      this.repassessment?.disable();
    } else {
      this.repassessment?.enable();
    }

    this.repassessment.get('declarationaccepted')?.valueChanges.subscribe(value => {
      if (value) {
        this.repassessment.patchValue({
          decleredrepName: this.viewintroducerRmassessment.introducer_assessment.managerName,
          date: this.getToday()
        }, { emitEvent: false });
        this.errormessage = '';
      } else {
        this.repassessment.patchValue({
          decleredrepName: null,
          date: null
        }, { emitEvent: false });
        if (value == false) {
          this.repassessment.get('declarationaccepted')?.markAllAsTouched();
        }

      }
    });

  }

  splitPercentageValidator(group: FormGroup) {
    const value1 = group.get('representative')?.value;
    const value2 = group.get('introducer')?.value;

    if (!value1 && value1 !== 0 || !value2 && value2 !== 0) {
      return null;
    }

    return Number(value1) + Number(value2) === 100
      ? null
      : { splitPercentage: true };
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  //  Generic FormArray getter
  get rectificationAttachemnts(): FormArray {
    return this.repassessment.get('rectificationAttachemnts') as FormArray;
  }

  //  Create row
  createRow(): FormGroup {
    return this.fb.group({
      categoryName: [''],
      document: [null],
      documentFilename: ['']

    });
  }

  //  Add row
  addRow(): void {
    this.rectificationAttachemnts.push(this.createRow());
  }


  async removeRow(index: number): Promise<void> {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to delete the Attachment?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.rectificationAttachemnts.length > 1) {
          if (this.getRectificationdocuments) {
            let id = this.getRectificationdocuments[index]?.id;
            let docTypeId = this.getRectificationdocuments[index]?.docTypeId;

            const data = {
              onboardingId: this.viewId,
              docTypeId: docTypeId,
              id: id
            }
            if (id != undefined) {
              const responseData = await this.documentUploadService
                .deleteonbordingdocument(data)
                .then((response) => {
                  return JSON.parse(response);
                })
                .catch((error) => {
                  // console.error(error);
                  return error;
                });
            }
          }
        }
        this.rectificationAttachemnts.removeAt(index);

      } else {
        // console.log('User cancelled');
      }
    });

  }

  onDocumentFileChange(event: any, index: number,): void {
    const file = event.target.files?.[0];
    const fileControl = this.rectificationAttachemnts.at(index).get('documentFilename');
    if (file) {
      this.rectificationAttachemnts.at(index).patchValue({
        document: file,
        documentFilename: file.name
      });
    }
    fileControl?.markAsTouched();
    fileControl?.updateValueAndValidity();
    if (!file) {
      fileControl?.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // ❌ Invalid type
    if (!allowedTypes.includes(file.type)) {
      fileControl?.setErrors({ invalidType: true });
      return;
    }

    // ❌ Invalid size
    if (file.size > maxSize) {
      fileControl?.setErrors({ maxSize: true });
      return;
    }

    // ✅ Valid file
    fileControl?.setErrors(null);
    // fileControl?.setValue(file);
    this.uploaddocument(index);
  }

  removeFile(controlName: string, fileVar: string, index: number) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.getRectificationdocuments) {
          let id;
          let docTypeId;
          this.getRectificationdocuments.forEach(item => {
            if (item?.onboardingDocumentType === this.rectificationAttachemnts.at(index).get('categoryName')?.value) {
              id = item.id,
                docTypeId = item.docTypeId
            }
          });

          const data = {
            onboardingId: this.viewId,
            docTypeId: docTypeId,
            id: id
          }
          if (id != undefined) {
            const responseData = await this.documentUploadService
              .deleteonbordingdocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                // console.error(error);
                return error;
              });
          }
        }
        this.rectificationAttachemnts.at(index).get(controlName)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.rectificationAttachemnts.at(index).get(fileVar)?.reset();
        this.rectificationAttachemnts.at(index).get(controlName)?.markAsTouched();
        this.rectificationAttachemnts.at(index).get(controlName)?.updateValueAndValidity();
        // }
      } else {
        // console.log('User cancelled');
      }
    });
  }

  async uploaddocument(index: number) {
    this.setSprinner.set(true);
    let uploadbdmdocuments = new OnboardingAssesmentModel();
    uploadbdmdocuments.setOnboardingid(this.viewId);
    uploadbdmdocuments.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    uploadbdmdocuments.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: this.rectificationAttachemnts.at(index).get('categoryName')?.value,
      fileName: this.rectificationAttachemnts.at(index).get('document')?.value?.name,
      data: this.rectificationAttachemnts.at(index).get('document')?.value instanceof Blob ? await this.convertToBase64(this.rectificationAttachemnts.at(index).get('document')?.value) : '',
      contentType: this.rectificationAttachemnts.at(index).get('document')?.value.type,
      responseValue: ''
    }]);

    const responseData = await this.documentUploadService
      .saveOnboardingassessment(uploadbdmdocuments)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
      this.viewIntroducerRepAssessment();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }

    }
  }

  // ---------- Other Attachments ----------

  /**
   * Restores any previously uploaded "Other Attachments" and always keeps at
   * least one empty row. Safe to call repeatedly (viewIntroducerRepAssessment()
   * runs again after every upload) - restoreOtherAttachment() only adds unseen
   * controls.
   */
  private buildOtherAttachments(): void {
    this.otherAttachmentDocuments.forEach(item => {
      const index = this.otherAttachmentIndexOf(item);
      if (index !== null) {
        this.restoreOtherAttachment(`${this.otherAttachmentPrefix}${index}`, item.fileName);
      }
    });

    if (this.otherAttachmentKeys.length === 0) {
      this.addOtherAttachment();
    }

    // The API lists the documents in its own order, so the rows are put back in row
    // order here. Left unsorted the fields swap places on every fetch, and because
    // the template hangs the remove button off every row but the first and the add
    // button off the last, those buttons end up on whichever rows came back first.
    this.otherAttachmentKeys.sort((a, b) => this.otherAttachmentRow(a) - this.otherAttachmentRow(b));
  }

  /** The row index sent as responseValue for an "Other Attachments" control key. */
  private otherAttachmentIndex(key: string): string {
    return key.slice(this.otherAttachmentPrefix.length);
  }

  /** Row index of a control key as a number, for matching and ordering. */
  private otherAttachmentRow(key: string): number {
    return Number(this.otherAttachmentIndex(key));
  }

  /**
   * Row index an uploaded document belongs to, or null when it isn't an "Other
   * Attachments" row. Uploads carry 'OtherAttachments' as the document type with
   * the index in responseValue; rows saved before that change kept the index in
   * the document type itself, so both shapes are recognised here. The index is
   * read as a number so a row is still matched when the API echoes it back in a
   * different form (' 2', 2) than the one that was sent.
   */
  private otherAttachmentIndexOf(item: OnboardingAssesment | undefined): number | null {
    const docType = item?.onboardingDocumentType ?? '';
    const raw = docType === this.otherAttachmentDescription
      ? String(item?.responseValue ?? '').trim()
      : docType.startsWith(this.otherAttachmentPrefix)
        ? docType.slice(this.otherAttachmentPrefix.length)
        : '';

    const row = Number(raw);
    return raw !== '' && Number.isFinite(row) ? row : null;
  }

  /** Locates the uploaded document behind an "Other Attachments" row, matched on its index. */
  private findOtherAttachmentDocument(key: string): OnboardingAssesment | undefined {
    const row = this.otherAttachmentRow(key);
    return this.otherAttachmentDocuments.find(item => this.otherAttachmentIndexOf(item) === row);
  }

  private restoreOtherAttachment(key: string, fileName: string): void {
    if (!this.otherAttachmentKeys.includes(key)) {
      this.repassessment.addControl(key, this.fb.control([null]));
      this.repassessment.addControl(`${key}fileName`, this.fb.control(''));
      this.otherAttachmentKeys.push(key);

      const seq = Number(key.slice(this.otherAttachmentPrefix.length));
      if (!Number.isNaN(seq) && seq > this.otherAttachmentSeq) {
        this.otherAttachmentSeq = seq;
      }
    }
    this.repassessment.get(`${key}fileName`)?.setValue(fileName);
  }

  /** Duplicates the "Other Attachments" field so another file can be attached. */
  addOtherAttachment(): void {
    const key = `${this.otherAttachmentPrefix}${++this.otherAttachmentSeq}`;
    this.repassessment.addControl(key, this.fb.control([null]));
    this.repassessment.addControl(`${key}fileName`, this.fb.control(''));
    this.otherAttachmentKeys.push(key);
  }

  /** Removes a duplicated "Other Attachments" row, deleting its uploaded file first when there is one. */
  removeOtherAttachment(key: string): void {
    if (!this.repassessment.get(`${key}fileName`)?.value) {
      this.dropOtherAttachment(key);
      return;
    }

    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data === true) {
        await this.deleteOtherAttachmentDocument(key);
        this.dropOtherAttachment(key);
      }
    });
  }

  /** Clears the uploaded file but keeps the "Other Attachments" field on screen. */
  removeOtherAttachmentFile(key: string): void {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data !== true) {
        return;
      }

      await this.deleteOtherAttachmentDocument(key);

      this.repassessment.get(key)?.reset();
      this.repassessment.get(`${key}fileName`)?.reset();
      const fileInput = document.getElementById(`${key}fileName`) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
      this.repassessment.get(`${key}fileName`)?.markAsTouched();
      this.repassessment.get(`${key}fileName`)?.updateValueAndValidity();
    });
  }

  private async deleteOtherAttachmentDocument(key: string): Promise<void> {
    const match = this.findOtherAttachmentDocument(key);
    if (!match?.id) {
      return;
    }

    const data = {
      onboardingId: this.viewId,
      docTypeId: match.docTypeId,
      id: match.id
    };

    await this.documentUploadService
      .deleteonbordingdocument(data)
      .then((response) => JSON.parse(response))
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.otherAttachmentDocuments = this.otherAttachmentDocuments.filter(item => item !== match);
  }

  private dropOtherAttachment(key: string): void {
    this.repassessment.removeControl(key);
    this.repassessment.removeControl(`${key}fileName`);
    this.otherAttachmentKeys = this.otherAttachmentKeys.filter(item => item !== key);
  }

  onOtherAttachmentFileChange(event: any, key: string): void {
    const file = event.target.files?.[0];
    const fileControl = this.repassessment.get(`${key}fileName`);

    this.repassessment.patchValue({
      [key]: file,
      [`${key}fileName`]: file?.name
    });

    if (!fileControl) return;

    fileControl.markAsTouched();
    fileControl.setErrors(null);

    if (!file) {
      fileControl.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      fileControl.setErrors({ invalidType: true });
      return;
    }

    if (file.size > maxSize) {
      fileControl.setErrors({ maxSize: true });
      return;
    }

    fileControl.updateValueAndValidity();
    this.uploadOtherAttachment(key);
  }

  /**
   * Uploads an "Other Attachment" through the same reviewer-side endpoint the
   * rectification attachments use. Every row is saved under the shared
   * 'OtherAttachments' category_name and is told apart by its index in
   * responseValue, so the row can be matched back on reload.
   */
  async uploadOtherAttachment(key: string): Promise<void> {
    const file = this.repassessment.get(key)?.value;
    if (!(file instanceof Blob)) {
      return;
    }

    this.setSprinner.set(true);
    let uploadOtherAttachments = new OnboardingAssesmentModel();
    uploadOtherAttachments.setOnboardingid(this.viewId);
    uploadOtherAttachments.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    uploadOtherAttachments.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: this.otherAttachmentDescription,
      fileName: (file as File).name,
      data: await this.convertToBase64(file as File),
      contentType: file.type,
      responseValue: this.otherAttachmentIndex(key)
    }]);

    const responseData = await this.documentUploadService
      .saveOnboardingassessment(uploadOtherAttachments)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
      this.getAllDocuments();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async getcetegorynameDropdownOptions() {

    const responseData = await this.introducerRepAssessmentService
      .getrectificationDocumentsCategorydropdown(this.designation)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      this.documentCategorynames = responseData.data.responsedata;
    }
  }

  showPreview = false;

  async previewAttachment(controlName: string,filename:string) {
    this.selectedItemFile = controlName;
    await this.loadOtherFile(controlName,filename);
    this.showPreview = true;
  
  }

  private findAttachment(fileVar: string): OnboardingAssesment | undefined {
    const matches = this.otherAttachmentDocuments?.filter(item => this.otherAttachmentIndexOf(item) === this.otherAttachmentRow(fileVar))
    return matches?.[matches.length - 1];
  }


  async loadOtherFile(category: string,filename:string) {

    const documentId = this.findAttachment(category)?.id;
    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.repassessment.get(filename)?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName =  this.repassessment.get(filename)?.value;
      this.resetZoom();
    }
  }

  async previewDoc(category: string, index: number) {
    this.selectedItemFile = category;
    await this.loadFile(category, index);
    this.showPreview = true;

  }

  async loadFile(category: string, index: number) {

    const documentId = this.getRectificationdocuments.find(
      document => document.onboardingDocumentType === category
    )?.id;

    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.rectificationAttachemnts.at(index).get('documentFilename')?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName = this.rectificationAttachemnts.at(index).get('documentFilename')?.value;
      this.resetZoom();
    }
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview() {
    this.showPreview = false;
    this.resetZoom();
  }


  async downloadPDF() {

    const formData: RepAssessmentForm = this.repassessment.value;

    const pdfBytes = await this.pdfService.generatePDF(
      'introducer',
      formData
    );

    const blob = new Blob([pdfBytes as any], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Introducer.pdf';
    link.click();
  }

  async getChecklistItems() {
    const responseData = await this.newIntroducerChecklistService
      .getChecklistItems(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {

      this.getchecklistItems = responseData.data.responsedata;

      this.checklistinvalidflag.set(
        this.getchecklistItems.length === 0 ||
        this.getchecklistItems
          .some(x => x.isCompleted == null || x.isCompleted == false)
      );

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }


  async getAllDocuments() {
    const responseData1 = await this.introducerRepAssessmentService
      .getRectificationdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    const allDocuments: OnboardingAssesment[] = responseData1.data.responsedata ?? [];
    this.getRectificationdocuments = allDocuments.filter(
      item => this.otherAttachmentIndexOf(item) === null
    );
    this.otherAttachmentDocuments = allDocuments.filter(
      item => this.otherAttachmentIndexOf(item) !== null
    );
    this.buildOtherAttachments();

  }

  async viewIntroducerRepAssessment() {
    this.setSprinner.set(true);
    let status = this.data.status;
    const responseData = await this.introducerRepAssessmentService
      .viewintroducerRmassessment(this.viewId, status)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    const responseData1 = await this.introducerRepAssessmentService
      .getRectificationdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewintroducerRmassessment = responseData.data.responsedata;
      this.status = this.viewintroducerRmassessment.introducer_assessment?.status;
      if (this.viewintroducerRmassessment?.remark[1]?.id != undefined) {
        this.status = 'Rectification';
      }
      // The documents list carries both the rectification attachments and the
      // "Other Attachments" - split them so each section only sees its own rows.
      const allDocuments: OnboardingAssesment[] = responseData1.data.responsedata ?? [];
      this.getRectificationdocuments = allDocuments.filter(
        item => this.otherAttachmentIndexOf(item) === null
      );
      this.otherAttachmentDocuments = allDocuments.filter(
        item => this.otherAttachmentIndexOf(item) !== null
      );
      this.buildOtherAttachments();
      //  Always show at least one row
      if (this.status === 'Rectification') {
        if (this.rectificationAttachemnts.length === 0) {
          this.addRow();
          this.getcetegorynameDropdownOptions();
          this.repassessment.controls['basicRecommendations'].disable();
        }
      }
      if (this.getRectificationdocuments.length > 0) {
        this.rectificationAttachemnts.clear();
        this.getRectificationdocuments.forEach((item, index) => {
          // if (index !== 0) {
          this.addRow();
          // }
          // if (item.onboardingDocumentType == this.documents.at(index).get('category_name')?.value) {
          this.rectificationAttachemnts.at(index).patchValue({
            categoryName: item.onboardingDocumentType,
            documentFilename: item.fileName
          },)
          // }
        });
      }
      if (this.isReadOnly() == true) {
        this.rectificationAttachemnts?.disable();
      }

      this.repassessment.controls['repName'].setValue(this.viewintroducerRmassessment.introducer_assessment.managerName);
      this.repassessment.controls['repCode'].setValue(this.viewintroducerRmassessment.introducer_assessment.repCode);
      this.repassessment.controls['representative'].setValue(this.viewintroducerRmassessment.introducer_assessment.commissionReprsentatitve);
      this.repassessment.controls['introducer'].setValue(this.viewintroducerRmassessment.introducer_assessment.commissionIntroducer);
      this.repassessment.controls['branch'].setValue(this.viewintroducerRmassessment.introducer_assessment.branch);
      if (!['1900-01-01T00:00:00Z','0001-01-01T00:00:00Z'].includes(this.viewintroducerRmassessment?.introducer_assessment.dateOfInterview)) {
        this.repassessment.controls['interviewDate'].setValue(this.viewintroducerRmassessment.introducer_assessment.dateOfInterview?.split('T')[0]);
      }
      this.repassessment.controls['basicRecommendations'].setValue(this.viewintroducerRmassessment?.remark[0]?.remarkContent);
      this.repassessment.controls['rectificationRecommendations'].setValue(this.viewintroducerRmassessment?.remark[1]?.remarkContent);
      this.repassessment.controls['declarationaccepted'].setValue(this.viewintroducerRmassessment.introducer_assessment.isAgreed);
      if (this.repassessment.get('declarationaccepted')?.value == true) {
        this.repassessment.controls['decleredrepName'].setValue(this.viewintroducerRmassessment.introducer_assessment.managerName);
        this.repassessment.controls['date'].setValue(this.viewintroducerRmassessment.introducer_assessment.declarationDate?.split('T')[0]);
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  openConfirmDialog() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Are you sure you want to submit this Application?',
        hidecancel: false,
      }
    });

    this.getChecklistItems();
    dialogRef.afterClosed().subscribe(result => {
      if (result.data === true) {
        if (this.repassessment.get('declarationaccepted')?.value == true) {
          if (this.checklistinvalidflag() === true) {
            this.errormessage = 'Please complete the checklist';
            this.submitted.set(false);
          } else {
            this.submitted.set(true);
            this.saveAndContinue();
          }
        } else {
          this.errormessage = 'Please check the decleartion';
          this.submitted.set(false);
        }

      } else {
        // console.log('User cancelled');
      }
    });
  }

  async saveAndContinue() {
    this.setSprinner.set(true);
    let saveIntroducerRepAssessment = new IntroducerRepAssessment();
    saveIntroducerRepAssessment.setId(this.viewId);
    if (this.status == 'Rectification') {
      saveIntroducerRepAssessment.setRemarkId(this.viewintroducerRmassessment?.remark[1]?.id ?? 0);
      saveIntroducerRepAssessment.setRemarkContent(this.repassessment.get('rectificationRecommendations')?.value);
    } else {
      saveIntroducerRepAssessment.setRemarkId(this.viewintroducerRmassessment?.remark[0]?.id ?? 0);
      saveIntroducerRepAssessment.setRemarkContent(this.repassessment.get('basicRecommendations')?.value);
    }
    if (this.repassessment.get('interviewDate')?.value) {
      const formatted = formatDate(
        this.repassessment.get('interviewDate')?.value,
        'yyyy-MM-dd',
        'en-US'
      );
      saveIntroducerRepAssessment.setDateofInterview(formatted + 'T00:00:00Z');
    }
    saveIntroducerRepAssessment.setCommissionReprsentatitve(String(this.repassessment.get('representative')?.value));
    saveIntroducerRepAssessment.setCommissionIntroducer(String(this.repassessment.get('introducer')?.value));
    saveIntroducerRepAssessment.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    if (this.submitted() == true) {
      saveIntroducerRepAssessment.setRm_not_applicable(this.repassessment.get('declarationaccepted')?.value);
      saveIntroducerRepAssessment.setRm_declaration_date(this.repassessment.get('date')?.value + 'T00:00:00Z');
    } else {
      saveIntroducerRepAssessment.setRm_not_applicable(false);
    }

    const responseData = await this.introducerRepAssessmentService
      .saveintroducerRmassessment(saveIntroducerRepAssessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewIntroducerRepAssessment();
      if (this.submitted() == true) {
        this.snackBarService.openSuccessSnackBar("Application submitted successfully!");
        this.router.navigate(['/agent-onboarding']);
      } else {
        this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async returnByRole() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to return the application ?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        this.setSprinner.set(true);
        let returndata = {
          id: this.viewId,
          status: 'Candidate Submission',
        };

        const responseData = await this.returnbyroleService
          .statusreturn(returndata)
          .then((response) => {
            return JSON.parse(response);
          })
          .catch((error) => {
            // console.error(error);
            return error;
          });
        this.setSprinner.set(false);
        if (responseData.status === HttpStatusCode.Ok) {
          this.snackBarService.openSuccessSnackBar("Application returned successfully!");
          this.router.navigate(['/agent-onboarding']);

        } else {
          if (responseData.code === HttpStatusCode.BadRequest) {
            // Display notification on API failure.
            this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
          }
          if (responseData.code === HttpStatusCode.Unauthorized) {
            this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
            this.router.navigate(['/login']);
          }
        }
      } else {
        // console.log('User cancelled');
      }
    });

  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;

        // Remove metadata prefix
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = error => reject(error);
    });
  }
}
